import { ThaloDataTable } from "@/components/thalo-data-table";
import { getColumns, getInitialColumnVisibility } from "@/opportunity/opportunity_table/columns";
import { useOpportunityCategories } from "@/api/api";
import { Opportunity } from "@/opportunity/opportunity";
import { useOpportunities } from "@/opportunity/api";
import { useOpportunityManagement } from "@/opportunity/OpportunityManagementContext";
import { useAuthentication } from "@/contexts/AuthenticationContext";
import Filters from "@/opportunity/opportunity_table/Filters";
import React from "react";
import { OpportunityManagementViewSelector } from "@/opportunity/OpportunityManagementViewSelector";

const OpportunityManagementTable = ({ organizationId, snoozedLocationIds, snoozedEquipmentIds }: { organizationId?: number, snoozedLocationIds: Set<number>, snoozedEquipmentIds: Set<number> }) => {

  const { user } = useAuthentication();

  const { filters, sorting, setSorting, pagination, setPagination, openOpportunity, openChangeOpportunityStatusModal } = useOpportunityManagement();
  const { data, isLoading } = useOpportunities({
    page: pagination.pageIndex + 1,
    pageSize: pagination.pageSize,
    sorting,
    filters,
  });

  const categoriesData = useOpportunityCategories({});

  const columns = getColumns({
    categories: categoriesData.data?.results || [],
    openChangeStatusModal: (opportunity) => {
      openChangeOpportunityStatusModal(opportunity)
    },
    showChangeStatus: user.is_staff
  });

  const initialColumnVisibility = getInitialColumnVisibility(columns)

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-row flex-wrap gap-3">
        <div className="flex flex-col gap-1">
          <span className="text-xs">View</span>
          <OpportunityManagementViewSelector />
        </div>
        <div className="flex flex-col gap-1">
          <span className="text-xs">Filters</span>
          <Filters organizationId={organizationId}/>
        </div>
      </div>
      <ThaloDataTable
        data={data?.results ||  []}
        columns={columns}
        isLoading={isLoading}
        pageCount={Math.ceil((data?.count || 0) / pagination.pageSize)}
        pagination={pagination}
        onPaginationChange={setPagination}
        sorting={sorting}
        onSortingChange={setSorting}
        onRowClick={(row: { original: Opportunity}) => openOpportunity(row.original)}
        initialColumnVisibility={initialColumnVisibility}
        rowHightlightClass={(row: { original: Opportunity }) =>
          (snoozedLocationIds.has(row.original.location.id) || snoozedEquipmentIds.has(row.original.installation.equipment)) ? "opacity-50" : ""
        }
      />
    </div>
  )
}

export default OpportunityManagementTable;
